// Account Popover behavior for desktop
(function() {
  const initializedPopovers = new WeakSet();

  function initializePopover(popover) {
    if (initializedPopovers.has(popover)) return;
    initializedPopovers.add(popover);

    const trigger = popover.querySelector('.account-popover__trigger');
    const panel = popover.querySelector('.account-popover__panel');
    let isOpen = false;
    let closeTimeout;

    function openPopover() {
      clearTimeout(closeTimeout);
      isOpen = true;
      panel.style.opacity = '1';
      panel.style.visibility = 'visible';
      panel.style.transform = 'translateY(0)';
      panel.style.pointerEvents = 'auto';
    }

    function closePopover() {
      closeTimeout = setTimeout(() => {
        isOpen = false;
        panel.style.opacity = '0';
        panel.style.visibility = 'hidden';
        panel.style.transform = 'translateY(-10px)';
        panel.style.pointerEvents = 'none';
      }, 200);
    }

    trigger.addEventListener('mouseenter', openPopover);
    trigger.addEventListener('mouseleave', closePopover);
    panel.addEventListener('mouseenter', openPopover);
    panel.addEventListener('mouseleave', closePopover);

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      if (isOpen) {
        closePopover();
      } else {
        openPopover();
      }
    });

    document.addEventListener('click', function(e) {
      if (!popover.contains(e.target)) {
        closePopover();
      }
    });
  }

  function initializeAllPopovers() {
    const popovers = document.querySelectorAll('.account-popover');
    popovers.forEach(function(popover) {
      initializePopover(popover);
    });
  }

  initializeAllPopovers();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('account-popover')) {
            initializePopover(node);
          }
          const nestedPopovers = node.querySelectorAll ? node.querySelectorAll('.account-popover') : [];
          if (nestedPopovers.length > 0) {
            nestedPopovers.forEach(function(popover) {
              initializePopover(popover);
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Account Drawer behavior for mobile
(function() {
  const initializedTriggers = new WeakSet();
  let mainDrawer = null;
  let mainOverlay = null;
  let mainPanel = null;
  let mainCloseButton = null;

  function initializeMainDrawer() {
    // Find the first drawer in the main header (not cloned)
    const titleBar = document.querySelector('.toggle-header__title-bar');
    if (!titleBar) return;

    mainDrawer = titleBar.querySelector('.account-drawer');
    if (!mainDrawer) return;

    mainOverlay = mainDrawer.querySelector('.account-drawer__overlay');
    mainPanel = mainDrawer.querySelector('.account-drawer__panel');
    mainCloseButton = mainDrawer.querySelector('.account-drawer__close-button');

    console.log('Main drawer initialized:', { mainDrawer, mainOverlay, mainPanel, mainCloseButton });
  }

  function openDrawer() {
    if (!mainDrawer) return;
    console.log('Opening drawer');
    mainDrawer.classList.add('account-drawer--open');
    document.body.classList.add('account-drawer-open');
  }

  function closeDrawer() {
    if (!mainDrawer) return;
    console.log('Closing drawer');
    mainDrawer.classList.remove('account-drawer--open');
    document.body.classList.remove('account-drawer-open');
  }

  function initializeTrigger(trigger) {
    if (initializedTriggers.has(trigger)) return;
    initializedTriggers.add(trigger);

    const isMainHeader = trigger.closest('.toggle-header__title-bar') !== null;
    console.log('Initializing trigger from:', isMainHeader ? 'main header' : 'slide-down header');

    trigger.addEventListener('click', function(e) {
      console.log('Trigger clicked from:', isMainHeader ? 'main header' : 'slide-down header');
      e.preventDefault();
      openDrawer();
    });
  }

  function initializeAllTriggers() {
    const triggers = document.querySelectorAll('.account-drawer__trigger');
    triggers.forEach(function(trigger) {
      initializeTrigger(trigger);
    });
  }

  // Initialize main drawer first
  initializeMainDrawer();

  // Set up close button and overlay
  if (mainCloseButton) {
    mainCloseButton.addEventListener('click', closeDrawer);
  }

  if (mainOverlay) {
    mainOverlay.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mainDrawer && mainDrawer.classList.contains('account-drawer--open')) {
      closeDrawer();
    }
  });

  // Initialize all triggers
  initializeAllTriggers();

  // Watch for new triggers being added (from cloned headers)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('account-drawer__trigger')) {
            initializeTrigger(node);
          }
          const nestedTriggers = node.querySelectorAll ? node.querySelectorAll('.account-drawer__trigger') : [];
          if (nestedTriggers.length > 0) {
            nestedTriggers.forEach(function(trigger) {
              initializeTrigger(trigger);
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
